/**
 * Individual pillar card component
 */
interface PillarCardProps {
  title: string;
  description: string;
}

export function PillarCard({ title, description }: PillarCardProps) {
  return (
    <div className="rounded-lg bg-white px-4 sm:px-6 md:px-8 lg:px-6 xl:px-8 3xl:px-10 py-8 sm:py-12 md:py-16 lg:py-12 xl:py-16 3xl:py-20 shadow-sm">
      {/* Orange accent line */}
      <div className="mb-3 sm:mb-4 lg:mb-3 xl:mb-4 3xl:mb-5 h-[4px] sm:h-[5px] w-[60px] sm:w-[70px] lg:w-[60px] xl:w-[70px] 3xl:w-[80px] rounded-full bg-bright-orange"></div>

      {/* Title */}
      <h3 className="mb-4 sm:mb-5 md:mb-6 lg:mb-4 xl:mb-6 3xl:mb-8 text-xl sm:text-2xl md:text-[32px] lg:text-[26px] xl:text-[30px] 2xl:text-[32px] 3xl:text-[36px] font-bold text-marine">
        {title}
      </h3>

      {/* Description */}
      <p className="text-lg sm:text-xl md:text-2xl lg:text-lg xl:text-xl 2xl:text-2xl 3xl:text-3xl font-light leading-relaxed sm:leading-7 md:leading-[33px] lg:leading-6 xl:leading-7 2xl:leading-[33px] 3xl:leading-[40px] text-marine">
        {description}
      </p>
    </div>
  );
}